import * as React from 'react';
import withData from '../../../../../boilerplate/redux/hocs/withData';
import { IWithDataProps } from '../../../../../boilerplate/redux/types/IWithDataProps';
import WidgetBoxError from '../../../../components/Layout/WidgetBox/WidgetBoxError';
import WidgetBoxSkeleton from '../../../../components/Layout/WidgetBox/WidgetBoxSkeleton';
import { IWidgetStyleType } from '../../../../types/IWidgetStyleType';
import { SlugType } from '../../../Base/types/SlugType';
import PromotionsAggregatedByStatesWidget
	from '../../components/PromotionsAggregatedByStatesWidget/PromotionsAggregatedByStatesWidget';
import { IPromotionsAggregatedByStateType } from '../../types/IPromotionsAggregatedByStateType';
import { getPromotionTypeApiFilterString } from '../../utils/fetchTypeHelper';
import DataStateService from '../../../../services/DataStateService';

interface IPromotionsAggregatedByStatesWidgetContainerProps {
	title: string;
	widgetKey: string;

	promotionLabel?: string;
	promotionLabelPlural?: string;

	limit?: number;
	placeholderLimit?: number;
	page?: number;

	style?: IWidgetStyleType;
	orderBy?: 'promotionCount'
	orderDir?: 'desc';

	fetchPriceProductPromotion?: boolean,
	fetchAssortementProductPromotions?: boolean,
	fetchProductPromotionGridGroupeds?: boolean,
	fetchVoucherProductPromotions?: boolean,

	routeCallbk: (item: IPromotionsAggregatedByStateType) => { name: string, params: {[key: string]: any} },

	brandSlug?: SlugType,
	productGroupSlug?: SlugType,
	stateSlug?: SlugType,
	vendorSlug?: SlugType,
	excludeSlug?: SlugType,
}

class PromotionsAggregatedByStatesWidgetContainerInner extends React.Component<IPromotionsAggregatedByStatesWidgetContainerProps & IWithDataProps> {
	public static defaultProps = {
		promotionLabel: 'Aktion',
		promotionLabelPlural: 'Aktionen',
	};

	public render () {
		const { data, widgetKey, title, promotionLabel, promotionLabelPlural, routeCallbk } = this.props;

		if (this.getStatesRespectingExclude(data).length === 0) {
			return null;
		}

		return (
			<PromotionsAggregatedByStatesWidget
				title={title}
				aggregatedEntries={this.getStatesRespectingExclude(data)}
				widgetKey={widgetKey}
				promotionLabel={promotionLabel}
				promotionLabelPlural={promotionLabelPlural}
				routeCallbk={routeCallbk}
			/>
		);
  }

	/**
	 * Makes sure to only return entries, we haven't excluded
	 *
	 * @param data
	 */
	private getStatesRespectingExclude (data: IPromotionsAggregatedByStateType[]): IPromotionsAggregatedByStateType[] {
		const { excludeSlug } = this.props;

		if (!excludeSlug) {
			return data;
		}

		return data.filter((stateAggregated: IPromotionsAggregatedByStateType) => {
			if (stateAggregated.group.slug === excludeSlug) {
				return false;
			}

			return true;
		});
	}
}

export default function PromotionsAggregatedByStatesWidgetContainer (props: IPromotionsAggregatedByStatesWidgetContainerProps) {
	let limit = ( props.limit ) ? props.limit : 50;
	if (props.excludeSlug) {
		limit++;
	}

	const placeholderLimit = ( props.placeholderLimit ) ? props.placeholderLimit : (props.limit) ? props.limit : 7;

	const promotionTypes = getPromotionTypeApiFilterString(props);

	const RenderComponent = withData(
		PromotionsAggregatedByStatesWidgetContainerInner,
		'promotionsAggregatedByStatesWidgetReducer',
		`promotions-aggregated-by-states-${props.widgetKey}-${DataStateService.getStateKey()}`,
		{
			page: props.page,
			size: limit,
			orderBy: props.orderBy,
			orderDir: props.orderDir,

			promotion_type: promotionTypes,

			brand: props.brandSlug,
			product_group: props.productGroupSlug,
			state: props.stateSlug,
			store_vendor: props.vendorSlug,
		},
		{
			LoadingComponent: () => (
				<WidgetBoxSkeleton
					title={props.title}
					rows={placeholderLimit}
					type="item"
					widgetKey={props.widgetKey}
					showValues={{
						title: true,
						subtitle: false,
						special: false,
						extra: false,
					}}
				/>
			),
			ErrorComponent: (errorProps: any) => (
				<WidgetBoxError
					errors={errorProps.errors}
					title={props.title}
					rows={placeholderLimit}
					type="item"
					widgetKey={props.widgetKey}
					showValues={{
						title: true,
						subtitle: false,
						special: false,
						extra: false,
					}}
				/>
			),
		}
	);

	return <RenderComponent {...props} />
}
